import React from "react";
import PropTypes from "prop-types";

import { Loading, LoginBackground } from "./LoadingIcon.styles";

const LoadingIcon = ({ background = true }) =>
  background ? (
    <LoginBackground>
      <Loading />
    </LoginBackground>
  ) : (
    <Loading />
  );
LoadingIcon.propTypes = {
  background: PropTypes.bool,
};

LoadingIcon.defaultProps = {
  background: true,
};

export default LoadingIcon;
